export const services = {
  loadBISuggestions: () => Promise.resolve(),
  loadTextAdsSuggestions: () => Promise.resolve(),
  loadImageAdsSuggestions: () => Promise.resolve(),
  loadImagesSuggestions: () => Promise.resolve(),
  loadKeywordsSuggestions: () => Promise.resolve(),
  loadRSASuggestions: () => Promise.resolve(),
  loadTargetsSuggestions: () => Promise.resolve(),
  loadBudgetSuggestions: () => Promise.resolve(),
};
